import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {PartnerType} from "../../../../../classes/partnerType";

@Component({
    selector: 'kan-partner-type-list',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanPartnerTypeList {
    @Input() public partnerTypes: PartnerType[];
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    public emitRefresh(): void {
        this.refresh.emit();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/partner-type/list/component.ts